"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./ComponentButtonPage"));



//////////////////
// WEBPACK FOOTER
// ./src/docs/pages/ComponentButtonPage/index.ts
// module id = 632
// module chunks = 0